import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    IconButton, Button, TableContainer, Paper, Table, TableHead,
    TableRow, TableCell, TableBody, Collapse, Box, Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const DetailsDialog = ({ open, onClose, rows, theme }) => {
    const [openMap, setOpenMap] = useState({});
    const toggle = id => setOpenMap(m => ({ ...m, [id]: !m[id] }));

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle>
                Détails du décompte
                <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ height: 400 }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: theme.palette.grey[300] }}>
                                <TableCell />
                                <TableCell>Numéro Pièce</TableCell>
                                <TableCell align="right">Montant total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map(row => {
                                const details = row.details ? JSON.parse(row.details) : [];
                                const isOpen = !!openMap[row.id];
                                return (
                                    <React.Fragment key={row.id}>
                                        <TableRow sx={{ backgroundColor: theme.palette.grey[100] }}>
                                            <TableCell>
                                                <IconButton size="small" onClick={() => toggle(row.id)}>
                                                    {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                </IconButton>
                                            </TableCell>
                                            <TableCell>Virement n° {row.numPiece}</TableCell>
                                            <TableCell align="right">
                                                {parseFloat(row.virementMontant||0).toLocaleString('fr-FR',{style:'currency',currency:'EUR'})}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ padding: 0 }} colSpan={5}>
                                                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                                                    <Box margin={1} sx={{ backgroundColor: theme.palette.grey[50], borderRadius: 1, p: 2 }}>
                                                        <Typography variant="subtitle1">Détails du virement</Typography>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Numéro dossier</TableCell>
                                                                    <TableCell>Nom assuré</TableCell>
                                                                    <TableCell>Prénom assuré</TableCell>
                                                                    <TableCell>Garantie</TableCell>
                                                                    <TableCell>Début période</TableCell>
                                                                    <TableCell>Fin période</TableCell>
                                                                    <TableCell align="right">Montant</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {details.map(d => (
                                                                    <TableRow key={d.id} sx={{ '&:nth-of-type(odd)': { backgroundColor: theme.palette.grey[100] } }}>
                                                                        <TableCell>{d.num_dossier}</TableCell>
                                                                        <TableCell>{d.nom_assure}</TableCell>
                                                                        <TableCell>{d.prenom_assure}</TableCell>
                                                                        <TableCell>{d.garantie}</TableCell>
                                                                        <TableCell>{d.debut_periode}</TableCell>
                                                                        <TableCell>{d.fin_periode}</TableCell>
                                                                        <TableCell align="right">{parseFloat(d.montant||0).toLocaleString('fr-FR',{style:'currency',currency:'EUR'})}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </Box>
                                                </Collapse>
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">Fermer</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DetailsDialog;